/**
 * Static Phoenix context marker (is_phoenix / app_surface / brand) used on non-event analytics
 * calls where super properties don't apply — identify traits, the Mixpanel People profile, and
 * the Mixpanel SDK's register() at init. Event-level track/page/trackLink calls get these via
 * super properties instead (see superProperties.ts), so no helper is needed there.
 */
export const PHOENIX_EVENT_CONTEXT = {
  is_phoenix: true,
  app_surface: 'customer_account',
  brand: 'lyka',
} as const

